import React, { useState, useEffect } from 'react'
import './style.scss'
import {
	Button,
	Card,
	CardContent,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Typography,
	Box,
} from '@mui/material'
import Grid from '@mui/material/Grid2';
import { getAreaDetails } from '../../services/area'
import { getSummary } from '../../services/dashboard'
import MainGrid from '../AppDashboard/components/MainGrid'
import styled from 'styled-components';

function generateDashboardData(data) {
	const {
		totalMemberCount,
		pendingMemberCount,
		nonCoastokMemberCount,
		coastokMemberCount,
		frontLinerCount,
		facilitatorCount,
		totalQuestionCount,
		answeredQuestionCount,
		unansweredQuestionCount,
		areaLeaderCount,
		assistantDirectorCount,
		areaCount,
		incompleteBookingCount,
		paymentCompleteBookingCount,
		paymentPendingBookingCount,
		subsidyRequestedBookingCount,
	} = data || {}
	const dashboardData = [
		{
			title: 'Total Members',
			value: `${totalMemberCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				200, 240, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320,
				360, 340, 380, 360, 400, 380, 420, 400, 640, 340, 460, 440, 480,
				460, 600, 880, 920,
			].slice(0, 30),
		},

		{
			title: 'COASTOK Members',
			value: `${coastokMemberCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				90, 110, 120, 130, 140, 150, 120, 150, 140, 150, 160, 170, 180,
				190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310,
				320, 330, 340, 350,
			].slice(0, 30),
		},
		{
			title: 'Pending Members (rounds atleast 4)',
			value: `${pendingMemberCount}`,
			interval: 'Last 30 days',
			trend: 'down', // Adjust based on actual trend logic
			data: [
				180, 200, 160, 180, 140, 160, 130, 160, 190, 170, 210, 200, 180,
				230, 210, 240, 230, 260, 240, 300, 220, 290, 260, 330, 290, 350,
				310, 360, 410, 450,
			].slice(0, 30),
		},
		{
			title: 'NON-COASTOK Members',
			value: `${nonCoastokMemberCount}`,
			interval: 'Last 30 days',
			trend: 'neutral', // Adjust based on actual trend logic
			data: [
				// Example trend data
				100, 120, 140, 160, 180, 200, 150, 180, 160, 170, 180, 210, 200,
				220, 240, 250, 270, 260, 280, 290, 300, 310, 320, 330, 340, 350,
				360, 380, 400, 420,
			].slice(0, 30),
		},
		{
			title: 'Frontliners',
			value: `${frontLinerCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				50, 60, 55, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
				125, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180, 185,
				190, 195,
			].slice(0, 30),
		},
		{
			title: 'Facilitators',
			value: `${facilitatorCount}`,
			interval: 'Last 30 days',
			trend: 'down', // Adjust based on actual trend logic
			data: [
				// Example trend data
				30, 40, 35, 45, 50, 40, 55, 50, 60, 55, 65, 60, 70, 75, 80, 85,
				90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150,
				155,
			].slice(0, 30),
		},

		{
			title: 'Area Leaders',
			value: `${areaLeaderCount}`,
			interval: 'Last 30 days',
			trend: 'neutral', // Adjust based on actual trend logic
			data: [
				// Example trend data
				60, 70, 65, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125,
				130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180, 185, 190,
				195, 200, 205,
			].slice(0, 30),
		},
		{
			title: 'Assistant Directors',
			value: `${assistantDirectorCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
				100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160,
				165,
			].slice(0, 30),
		},
		{
			title: 'Total Areas',
			value: `${areaCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				10, 12, 15, 18, 20, 22, 25, 28, 30, 32, 35, 37, 40, 42, 45, 48,
				50, 52, 55, 58, 60, 63, 65, 67, 70, 72, 75, 78, 80, 83,
			].slice(0, 30),
		},
		{
			title: 'Total Questions',
			value: `${totalQuestionCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				400, 420, 440, 460, 480, 500, 480, 520, 540, 560, 580, 600, 620,
				640, 660, 680, 700, 720, 740, 760, 780, 800, 820, 840, 860, 880,
				900, 920, 940, 960,
			].slice(0, 30),
		},
		{
			title: 'Answered Questions',
			value: `${answeredQuestionCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				300, 320, 340, 360, 380, 400, 360, 420, 440, 460, 480, 500, 520,
				540, 560, 580, 600, 620, 640, 660, 680, 700, 720, 740, 760, 780,
				800, 820, 840, 860,
			].slice(0, 30),
		},
		{
			title: 'Unanswered Questions',
			value: `${unansweredQuestionCount}`,
			interval: 'Last 30 days',
			trend: 'down', // Adjust based on actual trend logic
			data: [
				// Example trend data
				100, 120, 130, 140, 150, 160, 150, 160, 170, 180, 190, 200, 210,
				220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340,
				350, 360, 370, 380,
			].slice(0, 30),
		},
		{
			title: 'Incomplete Bookings',
			value: `${incompleteBookingCount}`,
			interval: 'Last 30 days',
			trend: 'down', // Adjust based on actual trend logic
			data: [
				// Example trend data
				80, 90, 85, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140,
				145, 150, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 205,
				210, 215, 220, 225,
			].slice(0, 30),
		},
		{
			title: 'Payment Complete Bookings',
			value: `${paymentCompleteBookingCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				70, 80, 85, 90, 95, 100, 105, 110,

				115, 120, 125, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175,
				180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230, 235, 240,
				245,
			].slice(0, 30),
		},
		{
			title: 'Payment Pending Bookings',
			value: `${paymentPendingBookingCount}`,
			interval: 'Last 30 days',
			trend: 'down', // Adjust based on actual trend logic
			data: [
				// Example trend data
				90, 95, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
				210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330,
				340, 350, 360, 370,
			].slice(0, 30),
		},
		{
			title: 'Subsidy Requested Bookings',
			value: `${subsidyRequestedBookingCount}`,
			interval: 'Last 30 days',
			trend: 'up', // Adjust based on actual trend logic
			data: [
				// Example trend data
				50, 60, 55, 70, 65, 80, 85, 90, 95, 100, 105, 110, 115, 120,
				125, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180, 185,
				190, 195, 200,
			].slice(0, 30),
		},
	]

	// This `dashboardData` array now includes all the state variables with the required format.
	return dashboardData
}

const DashboardContainer = () => {
	const [fromDate, setFromDate] = useState(undefined)
	const [toDate, setToDate] = useState(undefined)
	const [areas, setAreas] = useState([{ _id: '', name: 'All' }])
	const [areaId, setAreaId] = useState('')
	const [totalMemberCount, setTotalMemberCount] = useState(0)
	const [pendingMemberCount, setPendingMemberCount] = useState(0)
	const [nonCoastokMemberCount, setNonCoastokMemberCount] = useState(0)
	const [coastokMemberCount, setCoastokMemberCount] = useState(0)
	const [frontLinerCount, setFrontLinerCount] = useState(0)
	const [facilitatorCount, setFacilitatorCount] = useState(0)
	const [totalQuestionCount, setTotalQuestionCount] = useState(0)
	const [answeredQuestionCount, setAnsweredQuestionCount] = useState(0)
	const [unansweredQuestionCount, setUnansweredQuestionCount] = useState(0)
	const [areaLeaderCount, setAreaLeaderCount] = useState(0)
	const [assistantDirectorCount, setAssistantDirectorCount] = useState(0)
	const [areaCount, setAreaCount] = useState(0)
	const [incompleteBookingCount, setIncompleteBookingCount] = useState(0)
	const [paymentCompleteBookingCount, setPaymentCompleteBookingCount] = useState(0)
	const [paymentPendingBookingCount, setPaymentPendingBookingCount] = useState(0)
	const [subsidyRequestedBookingCount, setSubsidyRequestedBookingCount] = useState(0)
	const [monthlySadhnaCounts, setMonthlySadhnaCounts] = useState([])
	const [weeklySadhnaCounts, setWeeklySadhnaCounts] = useState([])
	const [topUserMonthlyCounts, setTopUserMonthlyCounts] = useState([])

	useEffect(() => {
		getSummaryDetails()
		getAreaDetails({ per_page: 100 }).then((res) => {
			setAreas([
				{ _id: '', name: 'All' },
				...res.data.data.map((area) => ({
					_id: area._id,
					name: area.name,
				})),
			])
			localStorage.setItem('AREAS', JSON.stringify(res.data.data))
		})
	}, [])

	const getSummaryDetails = async () => {
		const summary = await getSummary({ areaId, fromDate, toDate })
		setTotalMemberCount(summary?.data?.totalMemberCount)
		setPendingMemberCount(summary?.data?.pendingMemberCount)
		setNonCoastokMemberCount(
			summary?.data?.nonCoastokMemberCount -
			summary?.data?.pendingMemberCount
		)
		setCoastokMemberCount(summary?.data?.coastokMemberCount)
		setFrontLinerCount(summary?.data?.frontLinerCount)
		setFacilitatorCount(summary?.data?.facilitatorCount)
		setTotalQuestionCount(summary?.data?.totalQuestionCount)
		setAnsweredQuestionCount(summary?.data?.answeredQuestionCount)
		setUnansweredQuestionCount(summary?.data?.unansweredQuestionCount)
		setAreaLeaderCount(summary?.data?.areaLeaderCount)
		setAssistantDirectorCount(summary?.data?.assistantDirectorCount)
		setAreaCount(summary?.data?.areaCount)
		setIncompleteBookingCount(summary?.data?.incompleteBookingCount)
		setPaymentCompleteBookingCount(
			summary?.data?.paymentCompleteBookingCount
		)
		setPaymentPendingBookingCount(
			summary?.data?.paymentPendingBookingCount
		)
		setSubsidyRequestedBookingCount(
			summary?.data?.subsidyRequestedBookingCount
		)
		setMonthlySadhnaCounts(summary.data?.monthlySadhnaCounts || [])
		setWeeklySadhnaCounts(summary.data?.weeklySadhnaCounts || [])
		setTopUserMonthlyCounts(summary.data?.topUserMonthlyCounts || [])
	}

	const handleChange = (name, e) => {
		if (name === 'areaId') {
			setAreaId(e.target.value)
		}
	}

	const dashboardData = generateDashboardData({
		totalMemberCount,
		pendingMemberCount,
		nonCoastokMemberCount,
		coastokMemberCount,
		frontLinerCount,
		facilitatorCount,
		totalQuestionCount,
		answeredQuestionCount,
		unansweredQuestionCount,
		areaLeaderCount,
		assistantDirectorCount,
		areaCount,
		incompleteBookingCount,
		paymentCompleteBookingCount,
		paymentPendingBookingCount,
		subsidyRequestedBookingCount,
	})

	return (
		<div className="dashboard-container">
			<h2 className="greeting">Welcome back,</h2>

			{/* Controls Section - Mobile Optimized */}
			<div className="dashboard-controls">
				<Box sx={{
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					gap: { xs: 2, sm: 3 },
					alignItems: { xs: 'stretch', sm: 'flex-end' },
					maxWidth: { lg: '400px' },
					mb: 3
				}}>
					<Box sx={{ flex: 1 }}>
						<InputLabel
							id="demo-simple-select-label"
							sx={{
								fontSize: { xs: '0.875rem', sm: '1rem' },
								fontWeight: 600,
								color: '#000',
								mb: 1,
								display: 'block'
							}}
						>
							Select Area
						</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							value={areaId}
							onChange={(e) => handleChange('areaId', e)}
							displayEmpty
							size='small'
							fullWidth
							sx={{
								backgroundColor: 'background.paper',
								borderRadius: '12px',
								boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
								'& .MuiSelect-select': {
									fontSize: { xs: '0.875rem', sm: '1rem' },
									padding: '12px 16px',
									minHeight: '44px',
									display: 'flex',
									alignItems: 'center'
								},
								'& .MuiOutlinedInput-notchedOutline': {
									border: '2px solid',
									borderColor: 'divider',
									borderRadius: '12px',
									transition: 'all 0.2s ease'
								},
								'&:hover .MuiOutlinedInput-notchedOutline': {
									borderColor: 'primary.main',
									boxShadow: '0 4px 12px rgba(25, 118, 210, 0.15)'
								},
								'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
									borderColor: 'primary.main',
									borderWidth: '2px',
									boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.1)'
								}
							}}
						>
							{areas.map((area) => (
								<MenuItem
									key={area._id}
									value={area._id}
									sx={{
										fontSize: { xs: '0.875rem', sm: '1rem' },
										padding: '10px 16px',
										borderRadius: '8px',
										margin: '2px 8px',
										'&:hover': {
											backgroundColor: 'primary.light',
											color: 'primary.contrastText'
										},
										'&.Mui-selected': {
											backgroundColor: 'primary.main',
											color: 'primary.contrastText',
											'&:hover': {
												backgroundColor: 'primary.dark'
											}
										}
									}}
								>
									{area.name}
								</MenuItem>
							))}
						</Select>
					</Box>

					<Button
						variant="contained"
						onClick={getSummaryDetails}
						className="get-stats-btn"
						size='small'
						sx={{
							minHeight: '44px',
							fontSize: { xs: '0.875rem', sm: '1rem' },
							fontWeight: 600,
							textTransform: 'none',
							borderRadius: '12px',
							background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
							boxShadow: '0 4px 16px rgba(25, 118, 210, 0.3)',
							padding: '12px 24px',
							transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
							'&:hover': {
								background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
								boxShadow: '0 6px 24px rgba(25, 118, 210, 0.4)',
								transform: 'translateY(-2px)'
							},
							'&:active': {
								transform: 'translateY(0)'
							},
							'&:focus': {
								boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.2)'
							}
						}}
					>
						Get Stats
					</Button>
				</Box>
			</div>

			<MainGrid
				data={dashboardData}
				monthlySadhnaCounts={monthlySadhnaCounts}
				weeklySadhnaCounts={weeklySadhnaCounts}
				topUserMonthlyCounts={topUserMonthlyCounts}
			/>
		</div>
	)
}



export default DashboardContainer
